import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(tz);

export const MADRID_TIMEZONE = "Europe/Madrid";
export const CUTOFF_HOUR = 11;
export const CUTOFF_MINUTE = 10;

export function getMadridNow() {
	return dayjs().tz(MADRID_TIMEZONE);
}

export function getMadridCutoff(now = getMadridNow()) {
	return now
		.clone()
		.hour(CUTOFF_HOUR)
		.minute(CUTOFF_MINUTE)
		.second(0)
		.millisecond(0);
}

export function isBeforeMadridCutoff(now = getMadridNow()) {
	return now.isBefore(getMadridCutoff(now));
}

export function getNextMadridCutoff(now = getMadridNow()) {
	let cutoff = getMadridCutoff(now);

	if (!now.isBefore(cutoff)) {
		cutoff = cutoff.add(1, "day");
	}

	return cutoff;
}

export function getExpiresHeaderForNextMadridCutoff(now = getMadridNow()) {
	return getNextMadridCutoff(now)
		.utc()
		.format("ddd, DD MMM YYYY HH:mm:ss [GMT]");
}
